import { Handle } from "react-flow-renderer";
import styled, { css } from "styled-components";

export const ParallelEnd = styled.div`
  width: 43px;
  height: 43px;
  box-shadow: 0 0 0 1.2px #42464c;
  box-sizing: border-box;
  border-radius: 4px;
  transform: rotate(-45deg);
  background-color: #fff;

  display: flex;
  justify-content: center;
  align-items: center;

  path {
    stroke: #42464c;
    stroke-width: 0.4px;
  }

  &:hover {
    background: #cff8e7;
    box-shadow: 0 0 0 1.2px #40e5a0;
    path {
      stroke: #40e5a0;
      stroke-width: 0.4px;
    }
    div:first-child {
      box-shadow: 0 0 0 0.8px #40e5a0;
    }
  }

  &.critical {
    background: #d93333 !important;
    border: none !important;
    box-shadow: none !important;
    div:first-child {
      box-shadow: 0 0 0 0.8px #eff1f5;
    }
    path {
      stroke: #eff1f5;
    }
  }

  ${({ selected }) =>
    selected &&
    css`
      background: #fff !important;
      box-shadow: 0 0 3px 2px #40e5a0 !important;
      path {
        stroke: #42464c !important;
        stroke-width: 0.4px !important;
      }
      div:first-child {
        box-shadow: 0 0 0 0.8px #42464c !important;
      }
    `}
`;

export const HandleStyle = styled(Handle)`
  width: 8px;
  height: 8px;
`;

export const ParallelEndInside = styled.div`
  width: 35px;
  height: 35px;
  box-sizing: border-box;
  border-radius: 3px;
  box-shadow: 0 0 0 0.8px #42464c;
  display: flex;
  justify-content: center;
  align-items: center;
`;
